/**
 * @fileoverview Default dashboard configuration and grid layout constants for `DashboardCanvasBuilder`.
 * @module ui-admin/components/DashboardCanvasBuilder/dashboardDefaults
 *
 * Responsibilities: - Provide `DEFAULT_DASHBOARD_LAYOUT` and `DEFAULT_DASHBOARD_CONFIG` shared by
 *                     `tenant-web` and `system-web`.
 * Dependencies:     - @firesquirrel/local-db (DashboardConfig, DashboardGridSetup)
 * Architecture:     - Pure constants; zero data access.
 * Notes:            - Matches `05-dashboard-canvas-builder-spec.md` §8.
 */

import type { DashboardConfig, DashboardGridSetup } from '@firesquirrel/local-db';

export const DEFAULT_DASHBOARD_LAYOUT: DashboardGridSetup = {
  columns: 12,
  rowHeight: 80,
  gap: 16,
  cardRadius: 'md',
  showHeaderBanner: true,
};

export const DEFAULT_DASHBOARD_CONFIG: DashboardConfig = {
  layout: { ...DEFAULT_DASHBOARD_LAYOUT },
  widgets: [],
  autoRefreshSeconds: 0,
};
